// extracted by mini-css-extract-plugin
module.exports = {"mathWorkingInteraction":"mathWorking__mathWorkingInteraction___LA-ig","isTooWide":"mathWorking__isTooWide___Ru-Lr","message":"mathWorking__message___BT7w5"};